import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './SingleOffer.css';
import { MdUpdate } from 'react-icons/md';
import { motion } from "framer-motion";
import dataBase from '../../config';
import { ref, set, get, child, increment } from "firebase/database";
import { useAtom } from 'jotai';
import { useOffersToDisplay, useDetailedOffer, useOpenedOfferIndex, useCompaniesLogosUrls } from '../../data/GlobalStates';
import ImagesCarousel from '../ImagesCarousel/ImagesCarousel';

const SingleOffer = ({scrolledOffer, offer, company}) => {

  //stany lokalne:
  const [ countVisits, setCountVisits ] = useState(true);
  const [ OfferUserLogo, setOfferUserLogo ] = useState('');

  //stany globalne:
  const [ OffersToDisplay, setOffersToDisplay ] = useAtom(useOffersToDisplay);
  const [ DetailedOffer, setDetailedOffer] = useAtom(useDetailedOffer);
  const [ OpenedOfferIndex, setOpenedOfferIndex] = useAtom(useOpenedOfferIndex);
  const [ CompaniesLogosUrls, setCompaniesLogosUrls] = useAtom(useCompaniesLogosUrls);

  const db = dataBase; // DO ZAPISU
  const dbRef = ref(dataBase);// DO ODCZYTU

  const history = useHistory();

  useEffect(()=>{

    let isMounted = true;

    if ((window.location.href.includes('userPanel') || window.location.href.includes('AddOffer')) && !isMounted) {
      return
    } else {
      visitCounter(offer)
    }
    return () => {
      isMounted = false;
    };
  },[countVisits])


  const visitCounter = async (offer) => {
    try {
      await get(child(dbRef, `offers/${offer.id}`))
       .then((offerInDb) => {
        if ( offerInDb.val() && !offerInDb.val().listViews) {
          set(ref(db, `offers/${offer.id}/listViews`), 1)
        } else if (offerInDb.val() && offerInDb.val().listViews) {
          set(ref(db, `offers/${offer.id}/listViews`), increment(1))
        }
      })
    } catch (error) {
      const errMessage = {
        occurDate: Date.now(),
        actionType: 'ListViewsIncr',
        fbErrMsg:error.toLocaleString(),
      }
      set(ref(db, `errors/${new Date(errMessage.occurDate).toLocaleString('pl').slice(0,10).replace(/[.,#$[\]]/g,'')}/${errMessage.occurDate}`), errMessage)
    }
  };


  const slugify = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-');

        const switchOfferToDisplay = (offer) => { 

          const slug = slugify(offer.title);

         if (history.location.pathname.includes('/BazaFirm')) {
              setDetailedOffer({...offer, CompanyLogo: OfferUserLogo})
                history.push({
                   pathname: `/Oferty/${offer.id}/${slug}`,
                   from: 'BazaFirm',
                   state: company.name
                   })
          } else if ((history.location.pathname === '/' || history.location.pathname.includes('aktualnosci')) ) {
               setOpenedOfferIndex(OffersToDisplay.map(el => el.id).indexOf(offer.id)) // refactor do zmiany sposób scrollowania do otwartej oferty powiązane z f. handleScroll z komp. offersDisplay
                setDetailedOffer({...offer, CompanyLogo: OfferUserLogo})
                 history.push(`/Oferty/${offer.id}/${slug}`)
          }
        };


  const chooseClassName = (offer) => {
    if (window.location.href.includes('aktualnosci')) {
      return 'OfferDisplayWide' 
    } else if (window.location.href.includes('userPanel')) {
      return 'OfferDisplayUser'
    } else {
      return 'OfferDisplay'
    }
  };

  const cuttedTitle = (title) => {
    if (title.length >= 30) {
      return title.slice(0,30) + '...'
    } else if (title.length < 32) {
      return title
    }
  };

const cuttedDescription = (description) => {
  if (description.length > 120) {
    return description.slice(0, 110) + '...';
  } else {
    return description;
  }
};

function formatDateFromMilliseconds(ms) {
  const date = new Date(ms); // tworzymy obiekt Date z milisekund
  const year = date.getFullYear();
  const day = String(date.getDate()).padStart(2, '0'); // dzień z zerem wiodącym
  const month = String(date.getMonth() + 1).padStart(2, '0'); // miesiąc od 0, więc +1
  return `${year}-${day}-${month}`;
}

    return (
     <div className='SingleOfferMainDiv'>  
        <motion.div className={chooseClassName(offer)} key ={offer.addDate} >
          <h1 className='SingleOfferTitle' onClick={() => (switchOfferToDisplay(offer))} ref={scrolledOffer}>{cuttedTitle(offer.title)}</h1>
          <div className='LogoDiv' >
            { 
                offer.ImagesUrls || offer.YouTubeURL ?  <ImagesCarousel Images={offer.ImagesUrls} offer={offer} switchOfferToDisplay={ (offer) => (switchOfferToDisplay(offer))} /> : null
            } 
            </div>

             <div className='OfferDetails' onClick={() => (switchOfferToDisplay(offer))} ref={scrolledOffer}>
               
                   <p className='SingleOfferValues'>{cuttedDescription(offer.description)}</p>
        
                   <div className='Details2'>
                     <div className='CompanyAndDate'>
                         <div className='addDate'>
                           <MdUpdate className='ClockLogo'/>
                         <p>{formatDateFromMilliseconds(offer.addDate)}</p>
                    </div>

                     </div>        
            </div>
            </div>
</motion.div>
</div>
    )
}

export default SingleOffer;
